function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Icon");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Icon",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("text", {
  id: "Pizzascanner",
  fontFamily: "Questrial-Regular, Questrial",
  fontSize: 21,
  fontWeight: "normal",
  fill: "#00A698"
}, React.createElement("tspan", {
  x: 36,
  y: 26
}, "Pizzascanner")), React.createElement("g", {
  id: "emojione-monotone:pizza",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Icon",
  fill: "#00A698"
}, React.createElement("path", {
  d: "M30.9975,22.805 C30.957,11.025 20.9505,1.04 9.146,1.0025 L8.418,1 L8.243,1.707 L1.369,29.507 L1,31 L2.4925,30.628 L30.295,23.7075 L31,23.5315 L30.9975,22.805 M17.1055,26.036 C16.6815,24.9005 15.7265,23.945 14.291,24.309 C13.1055,24.609 12.3065,25.9895 12.625,27.151 L2.269,29.729 L8.312,5.288 C17.717,6.715 25.278,14.274 26.708,23.6455 L17.1055,26.036",
  id: "Icon-Shape"
}), React.createElement("path", {
  d: "M7.462,20.3010182 C8.2253844,20.3037242 8.9582103,20.0013053 9.4975,19.461 C10.0375108,18.923029 10.3404263,18.1917483 10.339005,17.4295 C10.3403594,16.6677054 10.0374236,15.9369155 9.4975,15.3995 C9.282,15.185 8.9035,15.184 8.689,15.3995 C8.46682519,15.6225105 8.46704884,15.9832652 8.6895,16.206 C9.016,16.5315 9.1965,16.9675 9.1965,17.43 C9.1965,17.8925 9.0175,18.328 8.6905,18.6535 C8.0345,19.3065 6.8895,19.3065 6.236,18.6545 C6.01054393,18.4370823 5.65345607,18.4370823 5.428,18.6545 C5.3211093,18.7613074 5.26109326,18.9062463 5.26118695,19.0573537 C5.26128086,19.2084611 5.32147678,19.3533253 5.4285,19.46 C5.96685254,20.0006032 6.69906525,20.3034264 7.462,20.3010182",
  id: "Icon-Path"
}), React.createElement("path", {
  d: "M15.7605,12.591 C15.6763712,12.9460073 15.6741484,13.3155063 15.754,13.6715 C15.9621664,14.5934459 16.6780032,15.3158821 17.598,15.5325 C17.8761952,15.5961804 18.1536105,15.4232984 18.219,15.1455 C18.2742094,14.8690936 18.1042515,14.5975997 17.8315,14.5265 C17.096,14.356 16.594,13.566 16.768,12.824 C16.9465391,12.0602595 17.7101101,11.5856012 18.474,11.7635 C18.6085,11.7945 18.748,11.772 18.8645,11.6985 C18.9815,11.6255 19.064,11.511 19.094,11.376 C19.1115,11.301 19.1125,11.2235 19.096,11.148 C19.0518533,10.9544969 18.9015984,10.8028848 18.7085,10.757 C18.0738291,10.6076705 17.4057813,10.7191619 16.854,11.0665 C16.2998054,11.4074594 15.9058066,11.9567517 15.7605,12.591",
  id: "Icon-Path"
}), React.createElement("path", {
  d: "M20.3215,21.3795 C19.9874575,21.2888553 19.6372796,21.2746705 19.297,21.338 C18.4176029,21.5015817 17.708666,22.15267 17.471,23.015 C17.4375748,23.1401825 17.4552512,23.2735161 17.52014,23.3856648 C17.5850287,23.4978136 17.6918136,23.5795894 17.817,23.613 C18.0767979,23.6760561 18.3404834,23.5246567 18.417,23.2685 C18.6035,22.5805 19.369,22.1345 20.065,22.3235 C20.4099468,22.4151752 20.7038195,22.6411619 20.881,22.951 C21.0595,23.262 21.1075,23.6235 21.014,23.969 C20.9697628,24.1313062 21.0123333,24.3049517 21.1266238,24.4283936 C21.2409143,24.5518355 21.4107734,24.607629 21.576,24.576 C21.7612448,24.5415716 21.9106663,24.4045695 21.961,24.223 C22.1225213,23.6290555 22.0398897,22.9951866 21.7315,22.4625 C21.4243843,21.9282161 20.9169147,21.5384362 20.3215,21.3795",
  id: "Icon-Path"
}), React.createElement("path", {
  d: "M18.425,17.774 C17.7765,15.876 15.6945,14.8535 13.769,15.49 C11.8445,16.1275 10.8075,18.184 11.454,20.08 C12.101,21.981 14.184,23.0015 16.111,22.364 C18.0325,21.728 19.0695,19.6715 18.425,17.774",
  id: "Icon-Path"
}), React.createElement("path", {
  d: "M20,19.513 C20.3885,20.6525 21.6405,21.267 22.8,20.884 C23.955,20.5 24.5765,19.266 24.1905,18.1255 C23.801,16.986 22.548,16.3715 21.3935,16.7525 C20.2365,17.1365 19.6135,18.371 20,19.513",
  id: "Icon-Path"
}), React.createElement("path", {
  d: "M8.9675,11.698 C9.4985,13.2515 11.2025,14.087 12.7775,13.5645 C14.349,13.0435 15.198,11.361 14.6705,9.8095 C14.139,8.259 12.4365,7.4235 10.8615,7.944 C9.2905,8.464 8.4415,10.1465 8.9675,11.698",
  id: "Icon-Path"
}), React.createElement("path", {
  d: "M10.3045,22.791 C9.7565,21.193 8.0015,20.3315 6.3805,20.865 C4.7635,21.4035 3.89,23.134 4.4325,24.731 C4.976,26.334 6.7295,27.1925 8.355,26.6555 C9.973,26.118 10.846,24.3875 10.3045,22.791",
  id: "Icon-Path"
})), React.createElement("rect", {
  id: "ViewBox",
  x: 0,
  y: 0,
  width: 32,
  height: 32
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "162px",
    height: "32px",
    viewBox: "0 0 162 32",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/Pizzascanner_Logo.de58e82e.svg";
export { SvgComponent as ReactComponent };